<template>
  <div class="index-right">
    <div class="card card1">
      <p class="title" >功能区</p>
      
      <ul class="icon-ul clearfix">
        <li  v-for="(item,i) in hasMenu.slice(0,7)" :key="i" :data-title="item.title" v-show="i<num">
          <a class="pngfix pngfix-icon" href="JavaScript:;" @click="goApplication(item)">
            <div class="img"  :alt="item.title">
                <img :src="'assets/'+item.imgUrl.split('icon/')[1]" alt="">
            </div>
            <p :title="item.title">{{item.title}}</p>
          </a>
        </li>
        <li>
          <a class="pngfix" href="JavaScript:;" v-if="hasMenu.length>7"  @click="showMoreMenu">
            <div class="big-img" >
              <img  src="assets/down.png" alt="">
                <!-- <i class="big-icon " :class="{'el-icon-arrow-down':!showMore,'el-icon-arrow-up':showMore}"></i> -->
            </div>
          </a>
        </li>
      </ul>
    </div>
    <div class="card card2">
      <p class="title">快捷入口</p>
      <ul class="date_list">
          <li v-show="num3">
            <router-link  to='upload'>
              <img src="@/assets/sczy_icon.svg" alt="">
              <p >上传资源</p>
            </router-link>
          </li>
          <li v-show="num1" @click="goUrl('/submit/toIndex.do')">
              <img src="@/assets/cjbs_icon.svg" alt="">
              <p >参加报送</p>
          </li>
          <li v-show="num2">
              <router-link  to='adjust'>
                <img src="@/assets/sqtk_icon.svg" alt="">
                <p >申请调课</p>
              </router-link>
          </li>
          <li v-if="num4">
              <router-link  to='gardeType'>
                <img src="@/assets/sccjd_icon.svg" alt="">
                <p >上传成绩单</p>
              </router-link>
          </li>
      </ul>
    </div>
    <div class="card card3">
      <p class="title">我的课表</p>
      <monthCalendar :obj="obj" />
    </div>
    <!-- <div class="card card2">
      <p class="title">数据统计 
        <i class="icon el-icon-arrow-right"></i>
      </p>
      <ul class="date_list">
          <li v-show="num1">
              <h1 class="color1">{{allData[1]}}</h1>
              <p >报送数据</p>
          </li>
          <li v-show="num2">
              <h1 class="color2">{{allData[0]}}</h1>
              <p >选课数据</p>
          </li>
          <li v-show="num3">
              <h1 class="color3">{{allData[2]}}</h1>
              <p >资源数据</p>
          </li>
      </ul>
    </div> -->
    <div class="card card4">
      <router-link  to="/help"   tag="a" class="" @click="goTop">
        <p class="title">帮助中心 <i class="icon el-icon-arrow-right"></i></p>
      </router-link>
      
      <ul class="help_list">
          <li v-for="item in helpList" :key="item.id" @click="goTop">
              <router-link  :to="'/help?id='+item.id"   tag="a" class="">
                <p ><b></b>{{item.title}}</p>
              </router-link>
          </li>
      </ul>
    </div>
    <div class="card card3">
      <p class="title" :title="info.name">{{info.name}}</p>
      <div v-html="info.content"></div>
       <back-top/>
    </div>

    <el-dialog
      class="mydialog"
      title="功能区"
      :visible.sync="dialogVisible"
      width="460px"
      :before-close="handleClose">
      <div class="card">
        <ul class="icon-ul clearfix">
          <li  v-for="(item,i) in hasMenu.slice(7)" :key="i" :data-title="item.title">
            <a class="pngfix pngfix-icon" href="JavaScript:;" @click="goApplication(item)">
              <div class="img"  :alt="item.title">
                  <img :src="'assets/'+item.imgUrl.split('icon/')[1]" alt="">
              </div>
              <p :title="item.title">{{item.title}}</p>
            </a>
          </li>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { backTop} from '@/components'
import { menutop,helpCenterList,schoolInfo,statistics} from '@/api/common_api'
import bus from '@/utils/bus'
import {mapActions, mapState} from 'vuex'
import monthCalendar from "./monthCalendar";
export default {
  name: "index-right",
  components: {
    monthCalendar,
    backTop
  },
  data() {
    return {
      menu:[],
      hasMenu:[],
      helpList:[],
      showMore:false,
      dialogVisible:false,
      num:7,
      info:{
        name:'',
        content:''
      },
      allData:[0,0,0],
      num1:false,
      num2:false,
      num3:false,
      num4:false,
    };
  },
  watch: {
    $route() {}
  },
  created() {
     this.getTopMenu()
  },
  computed: {
    ...mapState([
        'auth'
      ]),
  },
  methods: {
    ...mapActions([
      'getAuth'
    ]),
    
    goTop(){
      bus.$emit('gotop')
    },
    getTopMenu(){
      let _this = this
      
      menutop().then(res => {
        if (res.s == 1) {
          let obj=[]
          _this.hasMenu=res.d.filter(element =>{
            return element.state==1&&element.extra!=20;
            // return element.extra!=20
          })
          res.d.forEach(element => {
            if(element.extra==17||element.extra==18||element.extra==6||element.extra==14||element.extra==20){
              //判断是否有报送项目，无则显示宣传页面
              // if(element.extra==18&&element.state==0){
              //   _this.hasMenu.push(element)
              // }
              // if(element.extra==14&&element.state==0){
              //   _this.hasMenu.push(element)
              // }
              // if(element.extra==17&&element.state==0){
              //   _this.hasMenu.push(element)
              // }
              if(element.extra==18&&element.state==1){
                _this.num1=true
              }
              if(element.extra==14&&element.state==1){
                _this.num2=true
              }
              if(element.extra==17&&element.state==1){
                _this.num3=true
              }
              if(element.extra==20&&element.state==1){
                _this.num4=true
              }
              obj.push(element)
            }
          });
          _this.menu=res.d
          _this.getAuth({ auth:  obj });
         
        }
      })
      helpCenterList({page: 1,limit: 6}).then(res => {
        if (res.s == 1) {
         _this.helpList=res.d
        }
      })
      schoolInfo().then(res => {
        if (res.s == 1) {
         _this.info=res.d;
      
          document.title = _this.info.schoolName;
        }
      })
      statistics().then(res => {
        if (res.s == 1) {
         _this.allData=res.d
        }
      })
    },
    goApplication(item){
      if(item.state==1){
        let domain = window.location.host;
       
        let url= window.location.protocol+'//' + domain +item.url
        window.open(url)
      }else{
         this.$router.push({
          path: '/introduction',
          query: {
            extra:item.extra
          }
        })
      }
    },
    goUrl(toUrl){
      let domain = window.location.host;
      let url= window.location.protocol+'//' + domain +toUrl
      window.open(url)
    },
    showMoreMenu(){
      // if(this.showMore){
      //   this.num=7
      // }else{
      //   this.num=50
      // }
      this.dialogVisible=true
    }
  }
};
</script>
<style lang="less" scoped>
.index-right {
  padding-left: 10Px;
  font-size:14Px;
  .card {
    width: 100%;
    min-height:279Px;
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 4px 0px rgba(235, 235, 235, 0.5);
    padding:0 20Px 40Px 15Px;
    box-sizing: border-box;
    margin-bottom:10Px;
    a{
      color:#191919;
      .title{
        cursor: pointer;
      }
    }
    .title{
        line-height:50Px;
        border-bottom:1px solid #E5E5E5;
        .icon{
            float:right;
            line-height:50Px;
        }
     
    }
    .icon-ul li {
        float: left;
        width: 25%;
        text-align: center;
        cursor: pointer;
        .pngfix{
            padding: 0;
            margin: 0 auto;
            box-sizing: border-box;
            transition: 0.5s;
            min-height:20Px;
            display:inline-block;
            .img {
                display: inline-block;
                width: 50Px;
                height: 50Px;
                margin-top: 20Px;
                overflow: hidden;
                padding:10Px;
                box-sizing: border-box;
                img{
                    width:100%;
                    transition: 0.5s;
                }
                
            }
            .big-img{
               display: inline-block;
                width: 20Px;
                height: 20Px;
                margin-top: 50Px;
                overflow: hidden;
                // padding:10Px;
                box-sizing: border-box;
                img{
                    width:100%;
                    transition: 0.5s;
                }
            }
            p {
                width: 100%;
                line-height: 20Px;
                color: #444;
                transition: 0.5s;
                text-overflow: ellipsis;
                white-space: nowrap;
                cursor: pointer;
                overflow: hidden;
            }
        }
        .pngfix-icon:hover{
          img{ 
              transform:scale(1.2);
              -webkit-transform:scale(1.2);  /*兼容-webkit-引擎浏览器*/
              -moz-transform:scale(1.2);     /*兼容-moz-引擎浏览器*/
          }
          p{
              color:#1890FF;
          }
        }
        
    }
     .help_list{
         padding-top:15Px;
         color: #191919;
         li{
        
            line-height:35Px;
            p{
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
              &:hover{
                color:#1890FF;
              }
              cursor: pointer;
                b{
                    display: inline-block;
                    width:8Px;
                    height:8Px;
                    border-radius: 50%;
                    background: #D8D8D8;
                    margin-right:8Px;
                }
            }
        }
     }
  
  }
  .card2{
      height:153Px;
      min-height:153px;
      .title{
        cursor: default;
      }
      .date_list li{
        float: left;
        width: 25%;
        text-align: center;
        cursor: pointer;
        margin-top:24Px;
        h1{
            font-size:26Px;
            margin-bottom:20Px;
        }
        h1.color1{
            color:#FE7845;
        }
        h1.color2{
            color:#4FC317;
        }
        h1.color3{
            color:#FE646A;
        }
        p {
            width: 100%;
            line-height: 20Px;
            color: #444;
            transition: 0.5s;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-top: 8px;
        }
      }
  }
  .card4{
    height:294Px;
  }
  .card3{
      .title{
        line-height: 50Px;
        font-size: 14Px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      &>div{
        margin-top: 10Px;
      }
      padding:0Px 20Px 20Px 20Px;
      color:#666666;
      font-size:13Px;
      min-height:170Px;
      box-sizing: border-box;
      li{
          margin-bottom:15Px;
          &:last-child{
              margin-bottom: 0;
          }
      }
  }
}

.mydialog{
  .card {
    width: 100%;
    min-height:279Px;
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 4px 0px rgba(235, 235, 235, 0.5);
    padding:0 20Px 40Px 15Px;
    box-sizing: border-box;
    margin-bottom:10Px;
    a{
      color:#191919;
      .title{
        cursor: pointer;
      }
    }
    .title{
        line-height:50Px;
        border-bottom:1px solid #E5E5E5;
        .icon{
            float:right;
            line-height:50Px;
        }
     
    }
    .icon-ul li {
        float: left;
        width: 25%;
        text-align: center;
        cursor: pointer;
        margin-bottom: 20px;
        .pngfix{
            padding: 0;
            margin: 0 auto;
            box-sizing: border-box;
            transition: 0.5s;
            display:inline-block;
            .img {
                display: inline-block;
                width: 50Px;
                height: 50Px;
                overflow: hidden;
                padding:10Px;
                box-sizing: border-box;
                margin-top: 0;
                img{
                    width:100%;
                    transition: 0.5s;
                }
                
            }
            .big-img{
               display: inline-block;
                width: 20Px;
                height: 20Px;
                margin-top: 50Px;
                overflow: hidden;
                // padding:10Px;
                box-sizing: border-box;
                img{
                    width:100%;
                    transition: 0.5s;
                }
            }
            p {
                width: 100%;
                line-height: 20Px;
                color: #444;
                transition: 0.5s;
                text-overflow: ellipsis;
                white-space: nowrap;
                cursor: pointer;
                overflow: hidden;
            }
        }
        .pngfix-icon:hover{
          img{ 
              transform:scale(1.2);
              -webkit-transform:scale(1.2);  /*兼容-webkit-引擎浏览器*/
              -moz-transform:scale(1.2);     /*兼容-moz-引擎浏览器*/
          }
          p{
              color:#1890FF;
          }
        }
        
    }
     .help_list{
         padding-top:15Px;
         color: #191919;
         li{
        
            line-height:35Px;
            p{
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
              &:hover{
                color:#1890FF;
              }
              cursor: pointer;
                b{
                    display: inline-block;
                    width:8Px;
                    height:8Px;
                    border-radius: 50%;
                    background: #D8D8D8;
                    margin-right:8Px;
                }
            }
        }
     }
  
  }
}


</style>

